import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent } from '@ap/button';
import { ApFormControlPipe } from '@ap/cdk';
import { ApContentModule } from '@ap/content';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApPincodeInputComponent } from '@ap/input/pincode';

import { PincodeComponent } from './pincode.component';

/**
 * @ngdoc module
 * @name PincodeModule
 **/
@NgModule({
    imports: [ApContentModule, ApButtonComponent, ApFormErrorsComponent, ApFormControlPipe, ApPincodeInputComponent, ReactiveFormsModule],
    declarations: [PincodeComponent],
    exports: [PincodeComponent]
})
export class PincodeModule {}
